export class ParametersError extends Error {}
